import { render, staticRenderFns } from "./vnLayout.vue?vue&type=template&id=52d69156&"
import script from "./vnLayout.vue?vue&type=script&lang=js&"
export * from "./vnLayout.vue?vue&type=script&lang=js&"
import style0 from "./vnLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports